import {Component} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ReportsService} from "../services/reports/reports.service";
import {ISummaryStoryPoint, PointsReport, IStatusIcon} from "../reports/reports.objects";
import {ClientConfiguration} from "../services/configuration/client.config";
import {ModalConfig} from "../services/notification/modal.config";
import {ComponentBase} from "../base/ComponentBase";
import {PleaseWaitEvent, PleaseWaitTarget} from "../event/ContentEvents";
import {EventBus} from "../event/EventBus";
import {ReportEventData} from "../event/ActivityEvent";
import {Scilearn} from "../constants";
import {StepStateUpdater} from "../services/step/step-state";
import {RecordingBadge} from "../services/usermodel/usermodel.objects";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";

@Component({
    selector: "summary",
    templateUrl: "./summary.component.html",
    styleUrls: ["./summary.component.scss"]
})
export class SummaryComponent extends ComponentBase {

    public report:PointsReport;
    public storyPointList:ISummaryStoryPoint[];
    public imagePath:string = "";

    constructor(private reportsService:ReportsService,
                private config:ClientConfiguration,
                private modalConfig:ModalConfig,
                private eventBus: EventBus,
                private stepStateUpdater: StepStateUpdater,
                private audioQueueService: AudioQueueService) {
        super("SummaryComponent");
        let sub = reportsService.retrievePointsReport()
            .subscribe(response => {
                this.report = response.PointsReport;
                this.storyPointList = this.report.storyPoints;
                this.eventBus.next(new PleaseWaitEvent({show: false, audio: false, destination: PleaseWaitTarget.POINTS}));
            });
        this.subscriptions.push(sub);
    }

    public openFluencyReport(storyPoint: ISummaryStoryPoint): void {
        if (!!storyPoint.recordCount && storyPoint.recordCount > 0) {
            this.modalConfig.openModal(new ReportEventData({
                storyUniqName: storyPoint.storyUniqName, type:Scilearn.FLUENCY_MODAL, automatic: false, fluencyGoal: storyPoint.fluencyGoal, storyLoaded: false, coverImage:storyPoint.coverImage
            }));
        }
    }

    public openSelectionReport(storyPoint: ISummaryStoryPoint): void {
        if (storyPoint.storyCompleted) {
            this.modalConfig.openModal(new ReportEventData({storyUniqName: storyPoint.storyUniqName, type:Scilearn.SELECTION_MODAL, automatic: false, storyLoaded: false}));
        }
    }

    public getSummaryPanelHeight(): {"height": string} {
        return {"height": window.innerHeight - 52 + "px"};
    }

    public getCoverImage(storyPoint): string {
        return this.config.imageUrl + "points/" + storyPoint.coverImage;
    }

    public getSelectionSummaryIcon(storyPoint: ISummaryStoryPoint): IStatusIcon {
        if (!storyPoint.storyCompleted) {
            return {"icon-gold-star": false, "icon-silver-star": false, "icon-check-mark": false, "none": true};
        }

        return {
            "icon-gold-star": storyPoint.hasQuizStar && storyPoint.recordingBadge === RecordingBadge.GOLDEN,
            "icon-silver-star": storyPoint.hasQuizStar && storyPoint.recordingBadge === RecordingBadge.SILVER,
            "icon-check-mark": !storyPoint.hasQuizStar || storyPoint.recordingBadge === RecordingBadge.CHECKMARK,
            "none": false
        };
    }

    public getStepOneStatusIcon(storyPoint: ISummaryStoryPoint): IStatusIcon {
        if (this.stepStateUpdater.isStepNotCompleted(storyPoint.taqCompletionState)) {
            return {"icon-gold-star": false, "icon-silver-star": false, "icon-check-mark": false, "none": true};
        }

        return {
            "icon-gold-star": storyPoint.hasTAQStar,
            "icon-silver-star": false,
            "icon-check-mark": !storyPoint.hasTAQStar,
            "none": false
        };
    }

    public getStepTwoStatusIcon(storyPoint: ISummaryStoryPoint): IStatusIcon {
        if (this.stepStateUpdater.isStepNotCompleted(storyPoint.fluencyCompletionState)) {
            return {"icon-gold-star": false, "icon-silver-star": false, "icon-check-mark": false, "none": true};
        }

        return {
            "icon-gold-star": storyPoint.recordingBadge === RecordingBadge.GOLDEN,
            "icon-silver-star": storyPoint.recordingBadge === RecordingBadge.SILVER,
            "icon-check-mark": storyPoint.recordingBadge === RecordingBadge.CHECKMARK,
            "none": false
        };
    }

    public getStepThreeStatusIcon(learnerStory): IStatusIcon {
        if (this.stepStateUpdater.isStepNotCompleted(learnerStory.quizCompletionState)) {
            return {"icon-gold-star": false, "icon-silver-star": false, "icon-check-mark": false, "none": true};
        }

        return {
            "icon-gold-star": learnerStory.hasQuizStar,
            "icon-silver-star": false,
            "icon-check-mark": !learnerStory.hasQuizStar,
            "none": false
        };
    }

    public getTotalAttemptedPoints(storyPoint: ISummaryStoryPoint): number {
        return storyPoint.quizHighestPoint + storyPoint.taqFirstPoint + storyPoint.recordHighestPoint;
    }

    public getTotalPossiblePoints(storyPoint: ISummaryStoryPoint): number {
        return storyPoint.targetTAQTotalPoint + storyPoint.targetQuizTotalPoint + storyPoint.targetRecordTotalPoint;
    }

}
